import React from 'react';
import './Features.css';
import { useLanguage } from '../LanguageContext';
import card1Image from '../assets/images/card-1.png';
import card2Image from '../assets/images/card-2.png';
import card3Image from '../assets/images/card-3.png';

const Features = () => {
  const { t } = useLanguage();
  
  return (
    <div className="features">
      <h2 className="features-title">
        {t('featuresTitle')}
      </h2>
      
      <div className="features-grid">
        <div className="feature-card">
          <div className="card-image">
            <img src={card1Image} alt="Language Learning" className="card-img" />
          </div>
          <div className="card-content">
            <h3 className="card-title">{t('feature1Title')}</h3>
            <p className="card-description">
              {t('feature1Desc')}
            </p>
          </div>
        </div>

        <div className="feature-card">
          <div className="card-image">
            <img src={card2Image} alt="Local Insights" className="card-img" />
          </div>
          <div className="card-content">
            <h3 className="card-title">{t('feature2Title')}</h3>
            <p className="card-description">
              {t('feature2Desc')}
            </p>
          </div>
        </div>

        <div className="feature-card">
          <div className="card-image">
            <img src={card3Image} alt="Cultural Etiquette" className="card-img" />
          </div>
          <div className="card-content">
            <h3 className="card-title">{t('feature3Title')}</h3>
            <p className="card-description">
              {t('feature3Desc')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
